<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>Contactez-nous</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent">
    </mat-progress-bar>
    <!-- <form class="edit-form" [formGroup]="editForm"
          (submit)="onSubmit()" *ngIf="editForm">

          <mat-form-field class="subject-field">
            <mat-label>{{'contact.subject.label' | translate}}</mat-label>
            <input matInput formControlName="subject">
            <mat-error>{{'contact.subject.errorMessage' | translate}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="body-field">
            <mat-label>Votre message</mat-label>
            <textarea matInput rows="5" formControlName="body"></textarea>
            <mat-error>{{ 'contact.body.error' | translate: { maxLength: commentMaxLength } }}
            </mat-error>
        </mat-form-field>

          <section class="actions">
              <button mat-raised-button *ngIf="!isLoading" type="submit" color="primary"
                  [disabled]="editForm.invalid">
                  Envoyer un message
              </button>
              <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
          </section>
      </form> -->
    <ul *ngFor="let client of clients">
      <li class="clientTitle">
        <h3>Agence {{client.name}} </h3>
      </li>

      <section class="twoSection">
        <section class="leftSection">
          <li *ngIf="client.email">
            <span class="label">Email : </span>
            <span>{{client.email}}</span>
          </li>

          <li *ngIf="client.phone">
            <span class="label">Téléphone : </span>
            <span>{{client.phone}}</span>
          </li>

          <li *ngIf="client.fax">
            <span class="label">Fax : </span>
            <span>{{client.fax}}</span>
          </li>

          <li *ngIf="client.contact">
            <span class="label">Contact : </span>
            <span>{{client.contact}}</span>
          </li>

          <li *ngIf="client.website">
            <span class="label">Site : </span>
            <span>{{client.website}}</span>
          </li>
        </section>

        <section class="middleSection">
          <li *ngIf="client.siret">
            <span class="label">Siret : </span>
            <span>{{client.siret}}</span>
          </li>

          <li *ngIf="client.ape">
            <span class="label">APE : </span>
            <span>{{client.ape}}</span>
          </li>

          <li *ngIf="client.tva">
            <span class="label">TVA : </span>
            <span>{{client.tva}}</span>
          </li>
        </section>

        <section class="rightSection">
          <li *ngIf="client.street">
            <span class="label">Rue : </span>
            <span>{{client.street}}</span>
          </li>

          <li *ngIf="client.streetNumber">
            <span class="label">N° : </span>
            <span>{{client.streetNumber}}</span>
          </li>

          <li *ngIf="client.locality">
            <span class="label">Ville : </span>
            <span>{{client.locality}}</span>
          </li>
        </section>
      </section>


    </ul>
  </mat-card-content>
</mat-card>